import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { get } from 'lodash';
import SparkLineContainer from 'containers/charts/SparkLineContainer';
import ExportableCalloutWithChange from 'containers/callouts/ExportableCalloutWithChange';
import { formatNumbers } from 'helpers/formatNumbers';
import { getHelpText } from 'helpers/glossary';
import { glossary } from 'constants/glossary';
import ContentTile from 'components/atoms/layout/ContentTile';
import CallOutWrapper from 'components/atoms/callout/CallOutWrapper';
import Title from 'components/atoms/callout/Title';
import Value from 'components/atoms/callout/Value';
import DeltaWrapper, { DeltaWrapperPositive, DeltaWrapperNegative } from 'components/atoms/callout/DeltaWrapper';
import DeltaIcon from 'components/atoms/callout/DeltaIcon';
import {
    HelpBox,
    HelpClose,
    HelpBody,
    HelpTitle,
    HelpIcon,
} from 'components/atoms/callout/Help';
import {
    SparkLineWrapper,
    CategoriesWrapper,
    WindowsWrapper,
    WindowSpan,
} from 'components/atoms/callout/SparkLine';

const deltaMap = {
    'normal-positive': {
        wrapper: DeltaWrapperPositive,
        icon: props => `${props.theme.callouts.icons.positive}`,
        description: changeDisplay => `${changeDisplay}%`
    },
    'normal-negative': {
        wrapper: DeltaWrapperNegative,
        icon: props => `${props.theme.callouts.icons.negative}`,
        description: changeDisplay => `${Math.abs(changeDisplay)}%`
    },
    'invert-positive': {
        wrapper: DeltaWrapperNegative,
        icon: props => `${props.theme.callouts.icons.positive}`,
        description: changeDisplay => `${changeDisplay}%`
    },
    'invert-negative': {
        wrapper: DeltaWrapperPositive,
        icon: props => `${props.theme.callouts.icons.negative}`,
        description: changeDisplay => `${changeDisplay}%`
    },
    'normal-neutral': {
        wrapper: DeltaWrapper,
        icon: props => `${props.theme.callouts.icons.neutral}`,
        description: changeDisplay => `${changeDisplay}%`
    }
};

class CallOutValueWithChange extends Component {
    constructor(props) {
        super(props);
        this.state = { toggleHelp: false };
        this.toggleHelp = this.toggleHelp.bind(this);
    }

    toggleHelp() {
        this.setState({ toggleHelp: !this.state.toggleHelp });
    }

    render() {
        const { value, change, completeData, calloutWindow } = this.props.data;
        const { isLabelCoded } = this.props;

        const valueDisplay = formatNumbers(value, this.props.format);
        const changeDisplay = formatNumbers(change, '0,0');
        const deltaVisible = completeData ? 'visible' : 'hidden';
        const helpText = getHelpText({ glossaryKey: this.props.helpKey || this.props.type, glossary });

        let mapKey = 'normal-neutral';
        const invertedKey = this.props.invert ? 'invert' : 'normal';

        if (change > 0) {
            mapKey = `${invertedKey}-positive`;
        } else if (change < 0) {
            mapKey = `${invertedKey}-negative`;
        }
        const InternalDeltaWrapper = deltaMap[mapKey].wrapper;
        const deltaIcon = deltaMap[mapKey].icon(this.props);
        const description = deltaMap[mapKey].description(changeDisplay);
        const sparklineData = this.props.data.sparkline;
        const categories = sparklineData ?
            sparklineData.categories.map((d, index) => <span key={index}>{d}</span>) : [];
        return (
            <ContentTile>
                <CallOutWrapper data={this.props.data}>
                    <Value>{valueDisplay}</Value>
                    <Title>{this.props.title}</Title>
                    <InternalDeltaWrapper visible={deltaVisible}>
                        <DeltaIcon className={deltaIcon} />{description}
                    </InternalDeltaWrapper>
                    {!isLabelCoded ?
                        <HelpIcon className="icon-help-circle" onClick={this.toggleHelp.bind(this)} />
                        : null }
                    {sparklineData ?
                        <React.Fragment>
                            <SparkLineWrapper>
                                <SparkLineContainer
                                    animateDuration={this.props.animateDuration}
                                    data={sparklineData.data}
                                    y={this.props.type}
                                    exportName={`${this.props.exportName}-sparkline`} />
                            </SparkLineWrapper>
                            <CategoriesWrapper>{categories}</CategoriesWrapper>
                            <WindowsWrapper>{[
                                <WindowSpan key="1">{`Previous ${calloutWindow} Days`}</WindowSpan>, <WindowSpan key="2">{`Current ${calloutWindow} Days`}</WindowSpan>
                            ]}</WindowsWrapper>
                        </React.Fragment>
                        : null}
                    <HelpBox
                        onClick={this.toggleHelp.bind(this)}
                        className={this.state.toggleHelp ? 'show-help' : 'hide-help'} >
                        <HelpTitle>{this.props.title}</HelpTitle>
                        <HelpBody>{helpText}</HelpBody>
                        <HelpClose className="icon-close-circle"/>
                    </HelpBox>
                    <ExportableCalloutWithChange
                        exportName={this.props.exportName}
                        title={this.props.title}
                        value={valueDisplay}
                        deltaVisible={deltaVisible}
                        deltaState={mapKey}
                        description={description}
                        categories={get(sparklineData, 'categories', [])}
                        calloutWindow={calloutWindow} />
                </CallOutWrapper>
            </ContentTile>
        );
    }
}

CallOutValueWithChange.propTypes = {
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    data: PropTypes.shape({
        value: PropTypes.number.isRequired,
        change: PropTypes.number,
        completeData: PropTypes.bool,
        calloutWindow: PropTypes.number.isRequired
    }),
    format: PropTypes.string,
    invert: PropTypes.bool
};

export default withTheme(CallOutValueWithChange);



// WEBPACK FOOTER //
// ./src/components/molecules/CallOutValueWithChange.js